// Import the functions you need from the SDKs you need.
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
	apiKey: "AIzaSyDHRW1E-ygZmRSKa_1FyMtHXCn65P2erVI",
	authDomain: "control-room-react-app.firebaseapp.com",
	projectId: "control-room-react-app",
	storageBucket: "control-room-react-app.firebasestorage.app",
	messagingSenderId: "29800756650",
	appId: "1:29800756650:web:35aeea65668baee99aa7d3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
// const functions = getFunctions(app, "us-central1");

export { app, auth, db, storage };